import { IndentedSections } from '@openx/components-core/lib/IndentedSection/IndentedSections.tsx';
import type { Dispatch, SetStateAction } from 'react';
import type { AudienceListType, FormSegment } from '../../../../../../../../modules/audiences/AudienceForm/types.ts';
import { LocationBulkAdd } from './LocationBulkAdd.tsx';
import { LocationSegmentsList } from './LocationSegmentsList.tsx';
import { createSegmentDeleteHandler } from './utils/createSegmentDeleteHandler.ts';

export type LocationZipCodeProps = {
  isEdit?: boolean;
  listType: AudienceListType;
  locationZipCodeSegments: FormSegment[];
  setLocationZipCodeSegments: Dispatch<SetStateAction<FormSegment[]>>;
};

export const LocationZipCode = ({
  isEdit,
  listType,
  locationZipCodeSegments,
  setLocationZipCodeSegments,
}: LocationZipCodeProps) => {
  return (
    <IndentedSections>
      {isEdit && <LocationBulkAdd zipSegments={locationZipCodeSegments} setSegments={setLocationZipCodeSegments} />}

      {locationZipCodeSegments.length > 0 && (
        <LocationSegmentsList
          listType={listType}
          locationSegments={locationZipCodeSegments}
          onSegmentDelete={createSegmentDeleteHandler(locationZipCodeSegments, setLocationZipCodeSegments)}
          dataTest="zip"
        />
      )}
    </IndentedSections>
  );
};
